import { Vec2 } from "utils/math/vec2";
import { Texture } from "../../../texture";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";

export type RetouchMaskComponentProps = {
  texture: Texture;
  u_fromCoords: Vec2;
  u_toCoords: Vec2;
  u_brushSize?: number;
};

type RetouchMaskComponentState = {
  u_brushSize: number;
  u_hardness: number;
};

export class RetouchMaskComponent extends Webgl2Component<
  RetouchMaskComponentProps,
  RetouchMaskComponentState
> {
  constructor(initialState: RetouchMaskComponentState) {
    super(initialState);
  }

  public getRenderData(props: RetouchMaskComponentProps) {
    const material = Webgl2.materials.retouchMask;
    material.setTexture("u_texture0", props.texture);
    material.setUniforms({
      u_size: this.transform.size.getAbs().getArray(),
      u_fromCoords: props.u_fromCoords.getArray(),
      u_toCoords: props.u_toCoords.getArray(),
      u_brushSize: props.u_brushSize ?? this.state.u_brushSize,
      u_hardness: this.state.u_hardness,
    });
    return { material };
  }
}

export default RetouchMaskComponent;
